import styles from "./SkeletonItem.module.scss";
import { RenderWhen } from "../../infrastructure/components/RenderWhen";
import { classNames } from "primereact/utils";

interface ISkeletonItemProps {
  className?: string;
  isLoading: boolean;
  width?: string | number;
  value: JSX.Element | string | number | null | undefined;
}

export const SkeletonItem = ({
  className,
  isLoading,
  value,
  width = "60%",
}: ISkeletonItemProps) => {
  return (
    <span
      className={classNames(className, {
        [styles.skeleton_item]: isLoading,
      })}
      style={{ maxWidth: isLoading ? width : "auto" }}
    >
      <RenderWhen condition={!isLoading}>{value ?? ""}</RenderWhen>
    </span>
  );
};
